import CheckBox from "@avinet/adaptive-ui-core/form/controls/CheckBox";
import Input from "@avinet/adaptive-ui-core/form/controls/Input";
import List from "@avinet/adaptive-ui-core/form/controls/List";
import Media from "@avinet/adaptive-ui-core/form/controls/Media";
import NumberInput from "@avinet/adaptive-ui-core/form/controls/NumberInput";
import Rating from "@avinet/adaptive-ui-core/form/controls/Rating";
import { InputSection, InputSectionType } from "../../types/Section";

function getFormType(type: InputSectionType) {
  switch (type) {
    case InputSectionType.text:
      return "text";

    case InputSectionType.text_area:
      return "textarea";

    case InputSectionType.url:
      return "url";

    case InputSectionType.date:
      return "date";

    case InputSectionType.email:
      return "email";

    default:
      return "text";
  }
}

function getNumberFormType(type: InputSectionType) {
  switch (type) {
    case InputSectionType.decimal:
      return "decimal";

    case InputSectionType.integer:
    default:
      return "integer";
  }
}

export default function InputSectionRenderer({
  id,
  section,
}: {
  id: string;
  section: InputSection;
}) {
  switch (section.type) {
    case InputSectionType.text:
    case InputSectionType.text_area:
    case InputSectionType.url:
    case InputSectionType.email:
    case InputSectionType.date:
      return (
        <Input
          label={section.label}
          info={section.helpText}
          type={getFormType(section.type)}
          id={id}
          required={section.required}
        />
      );

    case InputSectionType.integer:
      return (
        <NumberInput
          label={section.label}
          info={section.helpText}
          type={getNumberFormType(section.type)}
          id={id}
          required={section.required}
          min={section.min}
          max={section.max}
        />
      );

    case InputSectionType.decimal:
      return (
        <NumberInput
          label={section.label}
          info={section.helpText}
          type={getNumberFormType(section.type)}
          id={id}
          required={section.required}
          min={section.min}
          max={section.max}
          decimals={section.decimals}
        />
      );

    case InputSectionType.boolean:
      return (
        <CheckBox
          label={section.label}
          info={section.helpText}
          id={id}
          required={section.required}
        />
      );

    case InputSectionType.list:
    case InputSectionType.multiselect_list:
      return (
        <List
          layout="vertical"
          id={id}
          label={section.label}
          info={section.helpText}
          required={section.required}
          items={section.items ?? []}
          multi={section.type === "multiselect_list"}
          noItemTranslation
        />
      );

    case InputSectionType.rating:
      return (
        <Rating
          id={id}
          label={section.label}
          info={section.helpText}
          required={section.required}
          max={section.max ?? 5}
          symbol={section.symbol}
        />
      );

    case InputSectionType.media:
      return (
        <Media
          id={id}
          label={section.label}
          info={section.helpText}
          required={section.required}
          accept={section.accept}
        />
      );

    default:
      return <p></p>;
  }
}
